// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"c4ce7d7a","316":"9e84c628","787":"e80b3c86","808":"c5d8f702"}[chunkId] + ".chunk.js";
};